/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TransactionSummaryReport } from './TransactionSummaryReport';
import {
    TransactionSummaryReportFromJSON,
    TransactionSummaryReportFromJSONTyped,
    TransactionSummaryReportToJSON,
} from './TransactionSummaryReport';

/**
 * 
 * @export
 * @interface TransactionSummaryReportViewModel
 */
export interface TransactionSummaryReportViewModel {
    /**
     * 
     * @type {Array<TransactionSummaryReport>}
     * @memberof TransactionSummaryReportViewModel
     */
    transactions: Array<TransactionSummaryReport>;
}

/**
 * Check if a given object implements the TransactionSummaryReportViewModel interface.
 */
export function instanceOfTransactionSummaryReportViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "transactions" in value;

    return isInstance;
}

export function TransactionSummaryReportViewModelFromJSON(json: any): TransactionSummaryReportViewModel {
    return TransactionSummaryReportViewModelFromJSONTyped(json, false);
}

export function TransactionSummaryReportViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionSummaryReportViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactions': ((json['Transactions'] as Array<any>).map(TransactionSummaryReportFromJSON)),
    };
}

export function TransactionSummaryReportViewModelToJSON(value?: TransactionSummaryReportViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Transactions': ((value.transactions as Array<any>).map(TransactionSummaryReportToJSON)),
    };
}

